import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { UIView } from "@uirouter/react";
import { useRef } from "react";
import styled from "styled-components";
import { Header } from "../../components/header";
import { useGlobalNotifications } from "../../components/hooks/use-global-notification";
import { useWindowSize } from "../../components/hooks/window-size-hook";
import { Flex } from "../../components/layout";
import { DesktopSidebar } from "../../components/sidebar/desktop";
import { MobileSidebar } from "../../components/sidebar/mobile";
import { useDefaultToEnglish } from "../../i18n";
import { colours } from "../../styles/colours";
import { device } from "../../styles/media";
import { ShellContext } from "./context";

export const contentPadding = "1em";

const Container = styled(Flex)`
  width: 100%;
  height: 100%;
  align-items: stretch;
  background: ${colours.grey};
`;

const Main = styled(Flex)`
  flex-direction: column;
  flex-grow: 1;
  align-items: stretch;
`;

const Content = styled.div`
  font-size: 0.8em;
  padding: ${contentPadding};
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  width: 100%;
  margin: 0 auto;

  @media ${device.tablet} {
    font-size: 1em;
  }
`;

const InternalContent = styled(Flex)`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  flex-grow: 1;
  flex-direction: column;
  align-items: stretch;
`;

export const Shell = () => {
  const { notification, handleClose } = useGlobalNotifications();
  const contentContainerRef = useRef<HTMLDivElement | null>(null);
  const { isMobile } = useWindowSize();
  useDefaultToEnglish();

  return (
    <ShellContext.Provider value={{ contentContainerRef }}>
      <Container>
        {isMobile ? <MobileSidebar /> : <DesktopSidebar />}
        <Main>
          <Header />
          <Content ref={contentContainerRef}>
            <InternalContent>
              <UIView />
            </InternalContent>
          </Content>
        </Main>
        <Snackbar
          open={!!notification}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <MuiAlert onClose={handleClose} severity={notification?.variant}>
            {notification?.title}
          </MuiAlert>
        </Snackbar>
      </Container>
    </ShellContext.Provider>
  );
};
